<template>
  <div class="item flex flex-row pointer" @click="toDetail(data)">
    <div v-if="data.goodsImage" class="item-img">
      <img :src="data.goodsImage" />
    </div>
    <div class="flex-1" :class="{ noImg: !data.goodsImage }">
      <div class="item-title">{{ data.goodsName }}</div>
      <div class="item-brief">{{ data.goodsBrief }}</div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {};
  },
  methods: {
    toDetail(data) {
      this.$router.push({ name: "journalDetail", query: { id: data.goodsId } });
    },
  },
};
</script>
<style lang="scss" scoped>
.item {
  padding: 15px;
  background: white;
  &-img {
    width: 94px;
    height: 128px;
    margin-right: 20px;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  &-title {
    font-size: 16px;
    font-weight: bold;
    color: #2c2c2c;
    margin-bottom: 10px;
  }
  &-brief {
    font-size: 14px;
    color: #777777;
    margin-bottom: 16px;
  }
}
.noImg {
  padding-left: 15px;
  padding-bottom: 10px;
}
</style>
